/*
 *  -----------------------------------------------------------------------
 *    <copyright file="multi-select-lov/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useMemo } from 'react';
import { orderBy } from '@progress/kendo-data-query';
import '../styles.scss';
import { getCodes } from 'country-list';
import CustomMultiSelect from '../multi-select';
import { MultiSelectLovProps } from '../multi-select.interface';
import { useTranslation } from '@hooks/index';

const MultiSelectLov = ({
    items,
    onChange,
    value,
    label,
    customClassName,
    popupClassName,
    customId,
    placeholder,
    field,
    error,
    allowCustom,
    disabled,
    addNewAction,
    orderByField = 'name',
    isCountryMultiSelect = false,
}: MultiSelectLovProps) => {
    const { t } = useTranslation();
    const countryCodes = useMemo(() => getCodes(), []);

    const isActive = (item: any) => {
        if (isCountryMultiSelect) {
            return countryCodes.includes(item.code);
        }
        return item.active;
    };

    const addWarningAndCountryId = (inputArray: any[]) =>
        inputArray.map((item) => ({
            ...item,
            showWarning: !isActive(item),
            ...(isCountryMultiSelect ? { id: item.code } : {}),
        }));

    const datasource = orderBy(addWarningAndCountryId(items), [{ field: orderByField, dir: 'asc' }]);

    const warning = value.some((item) => !isActive(item)) ? t('legacyMultiSelect.inactiveValues') : '';

    return (
        <CustomMultiSelect
            items={datasource}
            onChange={onChange}
            value={addWarningAndCountryId(value)}
            label={label}
            customClassName={customClassName}
            popupClassName={popupClassName}
            customId={customId}
            placeholder={placeholder}
            error={error}
            warning={warning}
            allowCustom={allowCustom}
            disabled={disabled}
            addNewAction={addNewAction}
        />
    );
};

export default MultiSelectLov;
